import { HorizontalGroup } from '@libs/uikit/Components';
import styled from 'styled-components';

export const Row = styled(HorizontalGroup)`
    font-size: 12px;
    & {
        padding: 8px 16px 8px 16px;
        border-bottom: 1px solid #e9ebec;
    }
    & div:nth-child(1) {
        flex: 1;
        align-self: flex-start;
    }

    & div:nth-child(2) {
        flex: 1;
        color: #EE1B24;
        font-weight: bolder;
        align-self: flex-start;
    }

    & div:nth-child(3) {
        flex: 6;
        word-break: break-word;
        
        & ul {
            list-style: none;

            & li {
                padding: 0 10px 10px 10px;
            }
        }
    }
`;
